import React from 'react';
import UploadBanner from '../UploadBanner';

const SourceUploadPanel = ({ uploading, uploadProgress, onFileChange }) => {
    return (
        <div className={uploading ? '' : 'welcome-content'}>
            {uploading ? (
                <UploadBanner state="uploading" uploadProgress={uploadProgress} />
            ) : (
                <div className="no-video-upload-container">
                    <svg className="no-video-upload-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="17 8 12 3 7 8" />
                        <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                    <p>Upload a timelapse video to get started</p>
                    <p className="no-video-upload-hint">Supports .mp4 files</p>
                    <input
                        type="file"
                        accept=".mp4"
                        onChange={onFileChange}
                        id="video-upload"
                        style={{ display: 'none' }}
                    />
                    <label htmlFor="video-upload" className="btn btn-teal capsule">
                        Upload Video
                    </label>
                </div>
            )}
        </div>
    );
};

export default SourceUploadPanel;
